import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forecast-cost-hour-data',
  templateUrl: './forecast-cost-hour-data.component.html',
  styleUrls: ['./forecast-cost-hour-data.component.css']
})
export class ForecastCostHourDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/forecast-cost-hour-data/forecast-cost-hour-data.component.ts